import React from 'react';
import { BannerProps } from 'design-system/src/components/Banner/Banner';
type Tabs =
  | 'dashboard'
  | 'prescriptions'
  | 'tasks'
  | 'pa_reviews'
  | 'notifications'
  | 'prior_auths'
  | 'fax_verification'
  | 'onboarding';

export type UserDefaultFilters = {
  providers: { npi: string; name: string }[];
};

export type User = {
  tabs: Tabs[];
  email: string;
  member_id: string;
  is_admin: boolean;
  practice_id: string | null;
  practice_name: string | null;
  ehr_name: string | null;
  has_ehr_integration_settings_tab: boolean;
  account_setup_complete: boolean;
  has_settings_page: boolean;
  new_feature_modal: {
    type: string | null;
    should_show: boolean;
  };
  feature_flags: {
    self_serve_onboarding?: boolean;
    show_ehr_upsells?: boolean;
    show_universal_search_nux?: boolean;
    show_get_started_panel?: boolean;
    [key: string]: boolean | undefined;
  };
  banners: BannerProps[];
  default_filters: UserDefaultFilters | null;
  notifications: {
    num_open_pa_reviews: number;
    num_tasks_requiring_response: number;
    num_portal_notifications: number;
  };
  show_tos?: boolean;
};

export type AuthContextType = {
  auth: boolean;
  user: User | null;
  loaded: boolean;
  setUser: (user: User | null) => void;
};

export const AuthContext = React.createContext<AuthContextType>({
  auth: false,
  user: null,
  loaded: false,
  setUser: () => {},
});
